export enum LikeStatus {
    like = 'like', // 点赞
    dislike = 'dislike', // 点踩
    default = 'default', // 未设置
}

export enum CardStatus {
    Init,
    Noraml,
    Loading,
    NoPermission,
    NotFound,
    LoadFail,
}

export interface ISummaryData {
    summaryId: string; // 摘要 Id
    canSummary: boolean; // 能否总结摘要
    summary: string; // 摘要内容
    img: string; // 截图地址，如果无法产生摘要，会有截图
    publishTime: string; // 摘要版本发布时间
    creator: string; // 文档创建人
    docGuid: string;
    likeStatus: LikeStatus | '';
    isHighLight: boolean; // 是否有高亮
    isCache?: boolean; // 是否为缓存数据
}
